<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="breadcrumbs" />
        <h1 class="page-title">Configurations</h1>
        <p class="page-subtitle">Paramètres de facturation de l'emplacement</p>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-row>
        <!-- Taxe Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card flat class="config-card">
            <v-card-text class="pa-5">
              <div class="config-icon mb-3">
                <v-icon color="primary" size="28">mdi-percent-outline</v-icon>
              </div>
              <div class="config-label">Taxe (%)</div>
              <div class="config-desc mb-3">Appliquée automatiquement sur les commandes et ventes</div>
              <v-text-field
                v-model.number="store.taxe"
                type="number"
                min="0"
                max="100"
                step="0.5"
                outlined
                dense
                hide-details
                suffix="%"
                @change="save"
              ></v-text-field>
              <div class="config-status mt-2">
                <v-chip x-small :color="store.taxe > 0 ? 'success' : 'grey'" dark>
                  {{ store.taxe > 0 ? 'Active : ' + store.taxe + '%' : 'Inactive' }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Service Fee Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card flat class="config-card">
            <v-card-text class="pa-5">
              <div class="config-icon mb-3">
                <v-icon color="secondary" size="28">mdi-room-service-outline</v-icon>
              </div>
              <div class="config-label">Frais de service (%)</div>
              <div class="config-desc mb-3">Frais de service appliqués sur les commandes restaurant</div>
              <v-text-field
                v-model.number="store.service_fee"
                type="number"
                min="0"
                max="100"
                step="0.5"
                outlined
                dense
                hide-details
                suffix="%"
                @change="save"
              ></v-text-field>
              <div class="config-status mt-2">
                <v-chip x-small :color="store.service_fee > 0 ? 'success' : 'grey'" dark>
                  {{ store.service_fee > 0 ? 'Active : ' + store.service_fee + '%' : 'Inactive' }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Info alert -->
      <v-alert type="info" text dense class="mt-4" style="font-size: 0.8125rem;">
        Les modifications sont sauvegardées automatiquement. Les taxes et frais de service seront appliqués aux nouvelles commandes et ventes.
        Si une valeur est à 0%, elle ne sera pas affichée sur les reçus.
      </v-alert>
    </div>

    <!-- Save notification -->
    <v-snackbar v-model="saved" color="success" timeout="2000" top>
      Configurations sauvegardées
    </v-snackbar>
  </div>
</template>

<script>
import PreloaderComponent from '../components/PreloaderComponent.vue'
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'

export default {
  name: 'ConfigurationsView',
  components: { PreloaderComponent, BreadcrumbComponent },
  data: () => ({
    enable: false,
    saved: false,
    store: { id: null, taxe: 0, service_fee: 0 },
    breadcrumbs: [
      { text: 'Compte', disabled: true },
      { text: 'Configurations', disabled: false },
    ],
  }),
  methods: {
    load() {
      try {
        var business_id = JSON.parse(localStorage.business).id
        var self = this
        this.$axios.get('/stores?business_id=' + business_id)
          .then(function (r) {
            if (r.data && r.data.length > 0) {
              self.store = r.data[0]
              self.enable = true
            }
          })
          .catch(function () { self.enable = true })
      } catch (e) {
        this.enable = true
      }
    },
    save() {
      if (!this.store.id) return
      var self = this
      var data = {
        taxe: this.store.taxe || 0,
        service_fee: this.store.service_fee || 0,
      }
      this.$axios.put('/stores/' + this.store.id + '?data=' + encodeURIComponent(JSON.stringify(data)))
        .then(function () {
          self.saved = true
        })
    },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.config-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  transition: box-shadow 0.2s;
}
.config-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;
}
.config-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.config-label {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
}
.config-desc {
  font-size: 0.75rem;
  color: #94a3b8;
  line-height: 1.4;
}
.config-status {
  font-size: 0.75rem;
}
</style>
